const initialState = {
  agencies: [],
  loading: false,
  error: null,
  length: 0,
};

const agenciesReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_AGENCES_LOADING":
      return {
        ...state,
        loading: true,
      };
    case "GET_AGENCES_SUCCESS":
      return {
        ...state,
        agencies: action.payload.data,
        loading: false,
        length: action.payload.meta.pagination.total,
      };
    case "GET_AGENCES_FAILURE":
      return initialState;
    default:
      return state;
  }
};
export default agenciesReducer;
